/** Thrown for any non-2xx response, carrying the parsed error envelope. */
export class ApiError extends Error {
    status;
    code;
    constructor(status, code, message) {
        super(message);
        this.name = 'ApiError';
        this.status = status;
        this.code = code;
    }
    static from(res) {
        const body = res.json;
        const err = body?.error;
        if (err && typeof err.code === 'string') {
            return new ApiError(res.status, err.code, err.message ?? err.code);
        }
        return new ApiError(res.status, 'unknown', `HTTP ${res.status}`);
    }
}
//# sourceMappingURL=transport.js.map